import React from "react";
import { isNil } from "lodash";
import StoryHeader from "components/pages/article/StoryHeader";
import TextColumnContainer from "./TextColumnContainer";
import ApiStory from "models/data/api/ApiStory";
import Time from "models/data/utils/Time";
import ShareSection from "components/pages/article/ShareSection";
import StoryBodyHtml from "components/pages/article/StoryBodyHtml";
import Feedback from "components/pages/article/Feedback";
import ApiTextEssay from "models/data/api/ApiTextEssay";
import ApiAuthor from "models/data/api/ApiAuthor";
import { RelatedStories } from "components/pages/article/RelatedStories";
import SharedStorySubscribe from "components/pages/article/SharedStorySubscribe";

const crosswordCategoryId = "1a8Czxb72TD7mwAGq5tUu2";

interface Props {
  story: any;
  onChangeFractionScrolled: (fractionScrolled: number) => void;
  paywalled: boolean;
  sharedStoryLinkExists: boolean;
}

class TextColumn extends React.Component<Props> {
  container = React.createRef();

  getFractionScrolled = (): number => {
    const scrollYBottom = window.scrollY + window.innerHeight;
    const scrollProgress = scrollYBottom - window.innerHeight;
    const fractionScrolled = scrollProgress / this.textColumnScrollDistance();
    return fractionScrolled;
  };

  componentDidMount(): void {
    window.onscroll = () => {
      this.props.onChangeFractionScrolled(this.getFractionScrolled());
    };

    window.onresize = () => {
      this.props.onChangeFractionScrolled(this.getFractionScrolled());
    };
  }

  componentWillUnmount(): void {
    window.onscroll = null;
  }

  textColumnScrollDistance = (): number => {
    const textColumn: any = this.container;
    if (isNil(textColumn) || isNil(textColumn.current)) return 0;
    const textColumnHeight = textColumn.current.offsetHeight;
    const textColumnScrollDistance = textColumnHeight - window.innerHeight + 64;
    return textColumnScrollDistance;
  };

  title = (): string => ApiStory.title(this.props.story);

  authorName = (): string => ApiStory.authorFullName(this.props.story);

  authorId = (): string => ApiAuthor.id(ApiStory.author(this.props.story));

  publicationDate = (): string =>
    Time.dateWrittenOut(ApiStory.publicationDate(this.props.story));

  bodyHtml = (): string =>
    ApiTextEssay.bodyHtml(ApiStory.textEssay(this.props.story));

  isCrosswordStory = (): boolean =>
    ApiStory.categories(this.props.story).some(
      (category) => category?.id === crosswordCategoryId
    );

  render(): JSX.Element {
    const { paywalled, sharedStoryLinkExists, story } = this.props;
    return (
      <TextColumnContainer
        className={`w-full ${
          this.isCrosswordStory() ? "lg:w-full" : " md:w-2/3 lg:w-1/2"
        }`}
        ref={this.container as React.RefObject<HTMLDivElement>}
      >
        <StoryHeader story={story} />
        {!paywalled && <ShareSection story={story} />}
        <StoryBodyHtml html={this.bodyHtml()} />
        {!paywalled && sharedStoryLinkExists && <SharedStorySubscribe />}
        {!paywalled && <Feedback story={story} />}
        {!paywalled && <RelatedStories story={story} />}
      </TextColumnContainer>
    );
  }
}

export default TextColumn;
